import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { blobConnectionInitialValue } from 'components/organisms/forms/blob-connection/BlobConnectionForm';
import { FormikHelpers } from 'formik';
import { useMutateOptions } from 'hooks';
import { useCustomParamId } from 'hooks/useParamId';
import { useTranslation } from 'react-i18next';
import { PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { usePostProviderBlobConnection } from 'services/providers/blob';
import { IProviderBlobConnectionResponse } from 'services/providers/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const CreateBlobConnection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const providerId = useCustomParamId('id', 'settings/provider');
  const salesChannelId = useCustomParamId(
    'salesChannelId',
    `settings/provider/${providerId}`
  );

  const createBlobConnection = usePostProviderBlobConnection();
  const mutateOptions = useMutateOptions<IProviderBlobConnectionResponse>();

  const onGoToDetail = () =>
    navigate(
      `/settings/provider/${providerId}/blob-connection/${salesChannelId}/keys`
    );

  const onCreateSale = async (
    values: IProviderBlobConnectionResponse,
    helpers: FormikHelpers<IProviderBlobConnectionResponse>
  ) => {
    await createBlobConnection.mutateAsync(
      { ...values, providerId, salesChannelId },
      {
        ...mutateOptions(helpers),
        onSuccess: () => onGoToDetail(),
      }
    );
  };

  return (
    <Form.BlobConnection
      i18nextPrefix='blob-connection'
      onSubmit={onCreateSale}
      initialValues={blobConnectionInitialValue}
      customBackItem={
        <Button
          type='button'
          onlyIcon
          onClick={() => navigate(`/settings/provider/${providerId}`)}>
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.create')} />
        </Button>
      }
    />
  );
};

export default CreateBlobConnection;
